import React from "react";

const SettingsPage = () => {
  return (
    <div>
      <h3 className="fw-bold">Settings</h3>
      <p className="text-muted">Customize your Afrogebeya experience.</p>

      <div className="card p-3 shadow-sm mt-3">
        <h5>Preferences</h5>

        <div className="form-check mt-3">
          <input type="checkbox" className="form-check-input" id="promo" />
          <label className="form-check-label" htmlFor="promo">
            Receive promotional emails
          </label>
        </div>

        <div className="form-check mt-2">
          <input type="checkbox" className="form-check-input" id="sms" />
          <label className="form-check-label" htmlFor="sms">
            Receive SMS updates
          </label>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
